// Used to remove the locale key from the variables object, mainly for ticketing API, since the locale is not needed for the query
export const removeLocale = <T extends Record<string, unknown>>(
  variables: T,
): Omit<T, 'locale'> => {
  const { locale, ...rest } = variables;
  return rest;
};
